import { useState } from 'react'
import { Button } from 'components'
import { LayoutTemplateModal } from './LayoutTemplateModal'

type ShowState = [boolean, (value: boolean) => void]

export const LayoutTemplateCopyButton = () => {
  const [show, setShow] = useState(false)

  const buttonText = '🎨 Layout Template copy'

  return (
    <>
      <Button primary onClick={() => setShow(true)}>
        {buttonText}
      </Button>
      <LayoutTemplateModal show={[show, setShow] as ShowState} />
    </>
  )
}

export default LayoutTemplateCopyButton
